import React from "react";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import { usePostApi } from "../../../hooks/post_api_hook/usePostApi";
import { url } from "../../../utils/confserveur";
import { useState, useEffect } from "react";
import TemplateProgressionNiveau from "./TemplateProgressionNiveau";
import { useUser } from "../../../context/UserContext";
import { useRef} from "react";
import { verifTitreSeq } from "../../../utils/sequencesfunction";
import { Calendar, Check, X, Upload, AlertTriangle } from 'lucide-react';
import { fetchSchoolHolidays, vacances } from "../../../utils/vacances";
import { useTheme } from "../../../hooks/fetch_api_hook/useTheme";
import PreviewSequence from "./PreviewSequence";
import ValidationImportSequence from "./ValidationImportSequence";
import Loading from "../../general/Loading"
const processCSVFile = async (file) => {
  const text = await file.text();
  
  // XLSX peut lire les CSV directement
  const workbook = XLSX.read(text, { 
    type: "string",
    raw: true,
    dateNF: 'dd/mm/yyyy'
  });
  
  // Un CSV n'a qu'une seule "feuille", on simule la structure attendue
  const sheetName = "Progressions";
  const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  
  // Convertir en tableau 2D (format attendu par le reste du code)
  const sheetData = XLSX.utils.sheet_to_json(worksheet, { 
    header: 1,
    raw: false, // Pour garder les dates au format texte
    dateNF: 'dd/mm/yyyy'
  });
  
  // Retourner dans le format attendu avec le nom de feuille "Progressions"
  return {
    [sheetName]: sheetData
  };
};

      // Fonction pour valider le format de date (DD/MM/YYYY)
 // Fonction pour valider les dates au format Excel (numérique ou texte DD/MM/YYYY)
 const isValidExcelDate = (date) => {
   
    if (typeof date === "number") {
      // Vérification pour les dates au format Excel
      const excelEpoch = new Date(Date.UTC(1899, 11, 30));
      const parsedDate = new Date(excelEpoch.getTime() + date * 86400000);
      return !isNaN(parsedDate.getTime());
    } else if (typeof date === "string") {
      // Vérification pour les dates au format texte (DD/MM/YYYY)
      const regex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!regex.test(date)) return false;

      const [day, month, year] = date.split("/").map(Number);
      const parsedDate = new Date(year, month - 1, day);

      return (
        parsedDate.getFullYear() === year &&
        parsedDate.getMonth() === month - 1 &&
        parsedDate.getDate() === day
      );
    }
    return false;
  };
    // Fonction pour formater les dates pour l'envoi au backend
    const formatExcelDateForBackend = (date) => {
        if (typeof date === "number") {
          const excelEpoch = new Date(Date.UTC(1899, 11, 30));
          const parsedDate = new Date(excelEpoch.getTime() + date * 86400000);
          return parsedDate.toISOString().split("T")[0]; // Retourne la date au format YYYY-MM-DD
        } else if (typeof date === "string" && isValidExcelDate(date)) {
          const [day, month, year] = date.split("/").map(Number);
          const parsedDate = new Date(year, month - 1, day);
          return parsedDate.toISOString().split("T")[0]; // Retourne la date au format YYYY-MM-DD
        }
        return null;
      };

const expectedHeaders = ["THEME", "TITRE SEQUENCE", "DUREE (semaines)"];

// Fonction pour obtenir les thèmes valides selon le niveau
const getValidThemesForLevel = (niveau, matiere) => {

  // Si c'est un prof de français
  if (matiere === 'Français' || matiere === 'français') {
    if (niveau === "6eme") {
      return [
        "LANGAGE ORAL",
        "LECTURE",
        "ECRITURE",
        "VOCABULAIRE",
        "GRAMMAIRE ET ORTHOGRAPHE GRAMMATICALE",
        "CULTURE LITTERAIRE ET ARTISTIQUE"
      ];
    } else {
      // Cycle 4 (5e, 4e, 3e)
      return [
        "LANGAGE ORAL",
        "LECTURE ET COMPREHENSION DE L'ECRIT",
        "ECRITURE",
        "ETUDE DE LA LANGUE",
        "CULTURE LITTERAIRE ET ARTISTIQUE"
      ];
    }
  }
  
  // Si c'est un prof de maths (ou par défaut)
  if (niveau === "6eme") {
    return [
      "NOMBRE, CALCUL ET RESOLUTION DE PROBLEMES",
      "INITIATION A LA PENSEE INFORMATIQUE",
      "LA PROPORTIONNALITE",
      "ORGANISATION ET GESTION DE DONNEES ET PROBABILITES",
      "ESPACE ET GEOMETRIE",
      "GRANDEURS ET MESURES"
    ];
  } else if (niveau === "5eme") {
    // Cycle 4 rénové — s'applique à la 5e uniquement pour l'instant ;
    // la 4e et la 3e resteront sur l'ancien cycle 4 jusqu'à leur bascule.
    return [
      "ESPACE ET GEOMETRIE",
      "LA PENSEE INFORMATIQUE",
      "NOMBRES ET CALCULS",
      "ORGANISATION ET GESTION DE DONNEES ET PROBABILITES",
      "PROPORTIONNALITE, FONCTIONS"
    ];
  } else {
    // Ancien cycle 4 (4e, 3e)
    return [
      "NOMBRE ET CALCULS",
      "ESPACE ET GEOMETRIE",
      "GRANDEURS ET MESURES",
      "ORGANISATION ET GESTION DE DONNEES, FONCTIONS",
      "ALGORITHMIQUE ET PROGRAMMATION"
    ];
  }
};

// Fonction global de validation des données.
    
  const validateData = ( sheets, filteredSequences, periode, selectedNiveau, matiere) => {

    const results = {
      progressions: [],
      errors: [],
    };
  
    // Fonction pour normaliser les chaînes (supprimer les accents, convertir en majuscules)
    const normalize = (text) =>
typeof text === "string" &&
      text
        ?.normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toUpperCase()
        .trim();

  
    // Obtenir les thèmes valides pour ce niveau
  const validThemes = getValidThemesForLevel(selectedNiveau, matiere);
  const normalizedValidThemes = validThemes.map(theme => normalize(theme));
 if (sheets["Progressions"]) {
    const sheetData = sheets["Progressions"];
    
    // Normaliser les en-têtes pour la validation
    const headersRow = sheetData[0].map((header) => normalize(header));
    
    if (!expectedHeaders.every((header, index) => headersRow[index] === normalize(header))) {
      results.errors.push(
        "Les en-têtes ne sont pas valides. Attendu : 'TITRE SEQUENCE' et 'DUREE (semaines)'"
      );
      return results;
    }
    
    // Vérifier l'unicité des titres
    const titlesSeen = new Set();
    const sequences = [];
    
    sheetData.slice(1).forEach((row, index) => {
      const lineNumber = index + 2;
      
      // Ignorer les lignes vides
      if (row.length === 0 || row.every((cell) => !cell)) {
        return;
      }
      
      // Vérifier que les 2 colonnes sont remplies
      if (row.length < 3 || !row[0] || !row[1] || !row[2]) {
        results.errors.push(`Ligne ${lineNumber} : Les trois colonnes doivent être remplies.`);
        return;
      }
      
      const theme = row[0].trim();
      const titre = row[1].trim();
      // Virgule française ACCEPTÉE : parseFloat("1,5") rendait 1 en silence
      // (il s'arrête à la virgule) et toutes les dates dérivaient. Un tableur
      // FR enregistre volontiers 1,5 : on normalise avant de parser.
      const duree = parseFloat(String(row[2]).trim().replace(',', '.'));
      // Vérifier que le thème est valide pour ce niveau
      const normalizedTheme = normalize(theme);
      if (!normalizedValidThemes.includes(normalizedTheme)) {
        results.errors.push(
          `Ligne ${lineNumber} : Le thème '${theme}' n'est pas valide pour le niveau ${selectedNiveau}. ` +
          `Thèmes autorisés : ${validThemes.join(", ")}`
        );
        return;
      }
      // Vérifier la durée
      if (isNaN(duree) || duree <= 0 || duree > 10) {
        results.errors.push(
          `Ligne ${lineNumber} : La durée doit être un nombre entre 0 et 10 semaines. Valeur reçue : '${row[2]}'`
        );
        return;
      }
      
      // Vérifier l'unicité dans le fichier
      if (titlesSeen.has(normalize(titre))) {
        results.errors.push(
          `Ligne ${lineNumber} : Le titre '${titre}' est déjà utilisé dans le fichier.`
        );
        return;
      }
      titlesSeen.add(normalize(titre));
      
      // Vérifier les doublons avec la BDD
      const eventToCheck = { title: titre };
      const titreErrors = verifTitreSeq(eventToCheck, filteredSequences);
      
      if (titreErrors.length > 0) {
        results.errors.push(
          `Ligne ${lineNumber} : ${titreErrors[0].message}`
        );
        return;
      }
      
      // Ajouter la séquence validée
      sequences.push({
        theme:theme,
        titre: titre,
        duree: duree
      });
    });
    
    // Périodes ABSENTES OU VIDES → erreur visible. Un échec de l'API
    // calendrier renvoie [] (truthy !) : l'ancien garde `&& periode` laissait
    // alors passer une prévisualisation silencieusement VIDE — étape 2
    // ouverte, zéro séquence, zéro erreur (bug « rien ne s'est passé »).
    if (!periode || periode.length === 0) {
      results.errors.push("Les périodes scolaires ne sont pas chargées.");
    } else if (results.errors.length === 0) {
      results.progressions = calculateSequenceDates(sequences, periode, vacances);
    }
    
  } else {
    results.errors.push("Le fichier CSV est vide ou mal formaté.");
  }
  
  return results;
};
const calculateSequenceDates = (sequences, periodes, vacances) => {
  if (!periodes || periodes.length === 0) return [];
  
  let currentDate = new Date(periodes[0].date_debut);
  const sequencesWithDates = [];
  let currentPeriodIndex = 0;
  
  sequences.forEach((seq) => {
    const dureeEnJours = seq.duree * 7;
    let joursRestants = dureeEnJours;
    let partNumber = 1;
    
    // Tant qu'il reste des jours pour cette séquence
    while (joursRestants > 0 && currentPeriodIndex < periodes.length) {
      // S'assurer qu'on commence bien au bon endroit
      const dateDebutPart = new Date(currentDate);
      const finPeriode = new Date(periodes[currentPeriodIndex].date_fin);
      
      // Calculer combien de jours on peut mettre dans cette période
      const joursDisponibles = Math.floor(
        (finPeriode - dateDebutPart) / (1000 * 60 * 60 * 24) + 1
      );
      
      if (joursDisponibles >= joursRestants) {
        // Tout rentre dans cette période
        const dateFin = new Date(dateDebutPart);
        dateFin.setDate(dateFin.getDate() + joursRestants - 1);
        
        sequencesWithDates.push({
          theme: seq.theme,
          titre: partNumber > 1 ? `${seq.titre} - Partie ${partNumber}` : seq.titre,
          duree: joursRestants / 7,
          dateDebut: dateDebutPart.toISOString().split('T')[0],
          dateFin: dateFin.toISOString().split('T')[0],
          periode: periodes[currentPeriodIndex].numero
        });
        
        // Préparer pour la séquence suivante
        currentDate = new Date(dateFin);
        currentDate.setDate(currentDate.getDate() + 1);
        joursRestants = 0;
        
      } else if (joursDisponibles > 0) {
        // On doit couper la séquence
        sequencesWithDates.push({
          theme: seq.theme,
          titre: `${seq.titre} - Partie ${partNumber}`,
          duree: joursDisponibles / 7,
          dateDebut: dateDebutPart.toISOString().split('T')[0],
          dateFin: finPeriode.toISOString().split('T')[0],
          periode: periodes[currentPeriodIndex].numero
        });
        
        joursRestants -= joursDisponibles;
        partNumber++;
        
        // Passer à la période suivante
        currentPeriodIndex++;
        if (currentPeriodIndex < periodes.length) {
          currentDate = new Date(periodes[currentPeriodIndex].date_debut);
        }
      } else {
        // Déjà à la fin, passer à la période suivante
        currentPeriodIndex++;
        if (currentPeriodIndex < periodes.length) {
          currentDate = new Date(periodes[currentPeriodIndex].date_debut);
        }
      }
    }
  });
  
  return sequencesWithDates;
};
  
  const ImportProgressionNiveau = ({ isOpen, onClose, selectedNiveau, etablissement, handleReload, filteredSequences }) => {
   
    const [etape, setEtape] = useState(1);
    const [previewData, setPreviewData] = useState(null);
    const [apiData , setApiData] = useState(null);
    const [validationResults, setValidationResults] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [periode, setPeriode] = useState()
    const [vacances, setVacances] = useState()
     const [dragOver, setDragOver] = useState(false);
     const [isSubmitting,setIsSubmitting] = useState(false);
     const [selectedAttendus, setSelectedAttendus] = useState({});
    const [, doPost] = usePostApi(
        url + "sequences/import_sequences/"
      );
    // Échec du chargement du calendrier scolaire (API externe) : bandeau +
    // Réessayer à l'étape 1 — sans lui, l'import échouait en silence jusqu'à
    // réouverture du modal.
    const [periodesErreur, setPeriodesErreur] = useState(false);
  const fileInputRef = useRef(null);

   const {data: ThemeDetail, isLoading, isError} = useTheme( selectedNiveau[0]
        );
  // Réutilisée par le bouton Réessayer du bandeau d'erreur
  const chargerCalendrier = async () => {
    const { vacances, periode, erreur } = await fetchSchoolHolidays();
    setPeriode(periode);
    setVacances(vacances);
    setPeriodesErreur(!!erreur || !periode || periode.length === 0);
  };
 useEffect(() => {
        chargerCalendrier();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
// En haut du composant, vous avez déjà l'import
const { user } = useUser();

// Fonction pour matcher le thème avec ThemeDetail
const findMatchingTheme = (sequenceTheme) => {
  if (!ThemeDetail || !sequenceTheme) return null;

  const normalizedSeqTheme = sequenceTheme
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();

  return ThemeDetail.find(theme => {
    const normalizedThemeName = theme.nom
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase()
      .trim();

    if (normalizedThemeName === normalizedSeqTheme) return true;

    // MATHS
    if (normalizedSeqTheme.includes("NOMBRE") && normalizedThemeName.includes("NOMBRE")) return true;
    if (normalizedSeqTheme.includes("ESPACE") && normalizedThemeName.includes("ESPACE")) return true;
    if (normalizedSeqTheme.includes("GRANDEURS") && normalizedThemeName.includes("GRANDEURS")) return true;
    if (normalizedSeqTheme.includes("ORGANISATION") && normalizedThemeName.includes("ORGANISATION")) return true;
    if (normalizedSeqTheme.includes("PROPORTIONNALITE") && normalizedThemeName.includes("PROPORTIONNALITE")) return true;
    if (normalizedSeqTheme.includes("INFORMATIQUE") && normalizedThemeName.includes("INFORMATIQUE")) return true;
    if (normalizedSeqTheme.includes("ALGORITHMIQUE") && normalizedThemeName.includes("ALGORITHMIQUE")) return true;

    // FRANÇAIS
    if (normalizedSeqTheme.includes("LANGAGE") && normalizedThemeName.includes("LANGAGE")) return true;
    if (normalizedSeqTheme.includes("LECTURE") && normalizedThemeName.includes("LECTURE")) return true;
    if (normalizedSeqTheme.includes("ECRITURE") && normalizedThemeName.includes("ECRITURE")) return true;
    if (normalizedSeqTheme.includes("VOCABULAIRE") && normalizedThemeName.includes("VOCABULAIRE")) return true;
    if (normalizedSeqTheme.includes("GRAMMAIRE") && normalizedThemeName.includes("GRAMMAIRE")) return true;
    if (normalizedSeqTheme.includes("ETUDE DE LA LANGUE") && normalizedThemeName.includes("ETUDE DE LA LANGUE")) return true;
    if (normalizedSeqTheme.includes("CULTURE") && normalizedThemeName.includes("CULTURE")) return true;

    return false;
  });
};

// Fonction pour préparer les séquences pour l'API
const prepareSequencesForAPI = () => {
  if (!previewData) return [];
  return previewData.map((seq, idx) => {
    const matchedTheme = findMatchingTheme(seq.theme);
    return {
      nom: seq.titre,
      debut: seq.dateDebut,
      fin: seq.dateFin,
      theme: matchedTheme ? matchedTheme.id : null,
      attendus: (selectedAttendus[`seq_${idx}`] || []).map(att => att.id)
    };
  });
};

/**
 * Thèmes du fichier qui n'ont PAS pu être rattachés au référentiel : soit le
 * référentiel du niveau est vide (ex. 5e français, pas encore livrée), soit
 * un libellé est inconnu. Une séquence DOIT porter un thème : le serveur
 * filtrant les listes par `theme__matiere`, une séquence sans thème devient
 * invisible pour TOUS les professeurs (créateur compris) et irrécupérable
 * depuis l'interface. On refuse donc l'import plutôt que de créer des
 * fantômes silencieux.
 */
const listerThemesNonRattaches = () => {
  if (!previewData) return [];
  const inconnus = new Set();
  previewData.forEach((seq) => {
    if (!findMatchingTheme(seq.theme)) inconnus.add(seq.theme);
  });
  return [...inconnus];
};

// Fonction pour passer à l'étape suivante (étape 2 -> 3)
const handleNextStep = () => {
  const inconnus = listerThemesNonRattaches();
  if (inconnus.length > 0) {
    const referentielVide = !ThemeDetail || ThemeDetail.length === 0;
    alert(
      "Import impossible : thème introuvable.\n\n"
      + (referentielVide
        ? `Le référentiel des thèmes de ${selectedNiveau} n'est pas encore disponible pour votre matière.`
        : `Ces thèmes du fichier ne correspondent à aucun thème de ${selectedNiveau} :\n- ${inconnus.join('\n- ')}`)
      + "\n\nChaque séquence doit être rattachée à un thème : sans cela, les séquences importées ne s'afficheraient chez aucun professeur."
    );
    return;
  }
  setApiData(prepareSequencesForAPI());
  setEtape(3);
};

 const handleBackStep = () => {
  // Si on est à l'étape 2 (prévisualisation), avertir l'utilisateur
  if (etape === 2) {
    const confirmation = window.confirm(
      "⚠️ Attention !\n\n" +
      "Si vous revenez en arrière, vous perdrez la progression importée et devrez la réimporter.\n\n" +
      "Êtes-vous sûr de vouloir continuer ?"
    );
    
    // Si l'utilisateur annule, on ne fait rien
    if (!confirmation) {
      return;
    }
    else {
      setPreviewData(null)
      setSelectedAttendus({})
    }
  }
  
  // Procéder au retour en arrière
  setEtape((prev) => prev - 1);
};


  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
         setSelectedFile(files[0]); 
      handleFileProcess(files[0]);
    }
  };
   const openFileDialog = () => {
    fileInputRef.current?.click();
  };
    // handleFileChange pour utiliser le process
const handleFileChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    await handleFileProcess(file);
  }
};
  // fonction séparée pour traiter le fichier
const handleFileProcess = async (file) => {
  setPreviewData(null);
  setSelectedFile(file);
  if (!file) return;

  try {
    const sheets = await processCSVFile(file);
    const validation = sheets && validateData(sheets, filteredSequences, periode, selectedNiveau, user.matiere);
    
    setValidationResults(validation);
    if (validation && validation.errors.length === 0) {
      // validation.progressions contient déjà les séquences avec les dates calculées !
      // Pas besoin de refaire le traitement
    
      setPreviewData(validation.progressions);
      setEtape(2)
    }
  } catch (error) {
    console.error("Erreur lors du traitement du fichier:", error);
    setValidationResults({ errors: ["Erreur lors de la lecture du fichier CSV"] });
  }
};
const getItemIdByName = (name) => {
    // Mapping des noms de thèmes en majuscules aux IDs correspondants
    const themeMapping = {
        "NOMBRES ET CALCULS": 1,
        "ESPACE ET GEOMETRIE": 2,
        "GRANDEURS ET MESURES": 3,
        "ORGANISATION ET GESTION DE DONNEES, FONCTIONS": 4,
        "ALGORITHMIQUE ET PROGRAMMATION": 5,
    };

    // Normalisation du nom pour correspondre au mapping (majuscule, suppression des espaces inutiles)
    const normalizedName = name.trim().toUpperCase();

    // Retourner l'ID correspondant ou null si le thème n'existe pas
    return themeMapping[normalizedName] || null;
};


    const handleSubmit = async () => {
      if (!validationResults || validationResults.errors.length > 0) {
        alert("Corrigez les erreurs avant de soumettre.");
        return;
      }
      // Filet de sécurité (le passage étape 2 → 3 garde déjà) : jamais de
      // POST avec une séquence sans thème, elle serait invisible pour tous.
      if (!apiData || apiData.some((s) => !s.theme)) {
        alert("Import annulé : au moins une séquence n'a pas de thème rattaché. Les séquences importées seraient invisibles pour tous les professeurs.");
        return;
      }

        const payload = {
          etablissement_id: etablissement.id,
          niveau: selectedNiveau,
          createur: user.id,
          progressions: apiData  // apiData contient déjà le format correct depuis prepareSequencesForAPI()
        };
         setIsSubmitting(true); // Activer le loading
  try {
    // Verdict lu sur le RETOUR de doPost ({ success }) — l'ancien test
    // `!isErrorPost && !isLoadingPost` lisait des états figés au render
    // (closure) et pouvait annoncer « succès ! » sur un POST échoué.
    const resultat = await doPost(payload);

        if (resultat?.success) {
          alert("Progressions importées avec succès !");
          handleReload();
          setValidationResults(null);
          setPreviewData(null);
          onClose();
        } else {
          alert("Erreur lors de l'importation des progressions.");
        }
      } catch (error) {
        console.error("Erreur lors de la soumission :", error);
        alert("Une erreur est survenue. Veuillez réessayer.");
      } finally {
            setIsSubmitting(false); // Désactiver le loading

      }
    };
  
    const renderValidationErrors = () => (
      <div className="mt-3 sm:mt-5 p-3 sm:p-4 bg-orange-50 border-2 border-orange-200 rounded-lg sm:rounded-xl overflow-auto max-h-[30vh] sm:max-h-[25vh]">
        <div className="flex items-start gap-2 sm:gap-3 mb-2 sm:mb-3">
          <div className="p-1.5 sm:p-2 bg-orange-500 rounded-lg flex-shrink-0">
            <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" x2="12" y1="8" y2="12"/>
              <line x1="12" x2="12.01" y1="16" y2="16"/>
            </svg>
          </div>
          <p className="text-sm sm:text-base md:text-lg font-semibold text-orange-700">Erreurs de validation</p>
        </div>
        <ul className="text-orange-600 text-xs sm:text-sm md:text-base list-disc pl-5 sm:pl-6 space-y-1 sm:space-y-2">
          {validationResults.errors.map((error, idx) => (
            <li key={idx}>
              {error}
            </li>
          ))}
        </ul>
      </div>
    );
  

    
    return (

<Modal
  isOpen={isOpen}
  onRequestClose={onClose}
  contentLabel="Import Progression"
  overlayClassName="custom-modal-overlay-sequence"
  className="custom-modal-content-sequence"
>
     <div className="bg-white rounded-2xl sm:rounded-3xl shadow-2xl w-full h-full relative overflow-hidden flex flex-col">

        {/* Header avec gradient bleuté et blobs animés */}
        <div className="relative overflow-hidden flex-shrink-0">
          {/* Background gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-sky-500 to-cyan-400" />

          {/* Animated liquid blobs */}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 800 200" preserveAspectRatio="none">
            <defs>
              <linearGradient id="progression-blob1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#67e8f9" stopOpacity="0.5" />
                <stop offset="100%" stopColor="#a5f3fc" stopOpacity="0.2" />
              </linearGradient>
              <linearGradient id="progression-blob2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#a5f3fc" stopOpacity="0.4" />
                <stop offset="100%" stopColor="#67e8f9" stopOpacity="0.1" />
              </linearGradient>
            </defs>

            {/* First animated blob */}
            <path fill="url(#progression-blob1)">
              <animate attributeName="d" dur="8s" repeatCount="indefinite"
                values="M0,100 Q200,50 400,80 Q600,120 800,70 L800,200 L0,200 Z;
                        M0,70 Q200,110 400,60 Q600,80 800,120 L800,200 L0,200 Z;
                        M0,100 Q200,50 400,80 Q600,120 800,70 L800,200 L0,200 Z" />
            </path>

            {/* Second animated blob */}
            <path fill="url(#progression-blob2)">
              <animate attributeName="d" dur="6s" repeatCount="indefinite"
                values="M0,130 Q300,90 500,110 Q700,140 800,95 L800,200 L0,200 Z;
                        M0,95 Q300,130 500,90 Q700,105 800,140 L800,200 L0,200 Z;
                        M0,130 Q300,90 500,110 Q700,140 800,95 L800,200 L0,200 Z" />
            </path>

            {/* Floating particles */}
            <circle cx="150" cy="80" r="2" fill="white" opacity="0.4">
              <animate attributeName="cy" dur="3s" values="80;50;80" repeatCount="indefinite" />
            </circle>
            <circle cx="650" cy="100" r="2" fill="white" opacity="0.3">
              <animate attributeName="cy" dur="4s" values="100;65;100" repeatCount="indefinite" />
            </circle>
            <circle cx="400" cy="70" r="2.5" fill="white" opacity="0.35">
              <animate attributeName="cy" dur="3.5s" values="70;45;70" repeatCount="indefinite" />
            </circle>
          </svg>

          {/* Header content */}
          <div className="relative px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between">
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="p-2 sm:p-3 bg-white/20 backdrop-blur rounded-lg sm:rounded-xl border border-white/30 shadow-xl">
                <Upload className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </div>
              <div>
                <h2 className="text-base sm:text-lg md:text-xl font-bold text-white">
                  Importer les progressions
                </h2>
                <p className="text-white/80 text-xs sm:text-sm">
                  Niveau {selectedNiveau} · Fichier CSV
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-1.5 sm:p-2 hover:bg-white/20 rounded-lg sm:rounded-xl transition-colors"
            >
              <X className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            </button>
          </div>

          {/* Indicateur d'étapes intégré dans le header */}
          <div className="relative px-4 sm:px-6 pb-4">
            <div className="flex items-center justify-center gap-2 sm:gap-4">
              {[
                { num: 1, label: 'Import' },
                { num: 2, label: 'Prévisualisation' },
                { num: 3, label: 'Validation' }
              ].map((step, idx) => (
                <div key={idx} className="flex items-center gap-1 sm:gap-2">
                  <div className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full transition-all duration-300 ${
                    etape === step.num
                      ? 'bg-white text-blue-600 shadow-lg scale-105'
                      : etape > step.num
                        ? 'bg-emerald-500/90 text-white shadow-md'
                        : 'bg-white/20 text-white/70'
                  }`}>
                    <span className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center text-[10px] sm:text-xs font-bold transition-all duration-300 ${
                      etape === step.num
                        ? 'bg-blue-600 text-white'
                        : etape > step.num
                          ? 'bg-white text-emerald-600'
                          : 'bg-white/30 text-white'
                    }`}>
                      {etape > step.num ? <Check className="w-3 h-3 sm:w-4 sm:h-4" /> : step.num}
                    </span>
                    <span className="text-[10px] sm:text-xs font-medium hidden xs:inline">{step.label}</span>
                  </div>
                  {idx < 2 && (
                    <div className="relative w-6 sm:w-12 h-0.5 sm:h-1">
                      <div className="absolute inset-0 bg-white/20 rounded-full"></div>
                      <div className={`absolute inset-y-0 left-0 rounded-full transition-all duration-500 ${
                        etape > step.num
                          ? 'w-full bg-gradient-to-r from-emerald-400 to-sky-400'
                          : 'w-0 bg-white'
                      }`}></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Contenu scrollable */}
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 md:p-8">
          {etape === 1 && (
            <>
              {/* Icône et titre */}
              <div className="flex flex-col items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-gradient-to-br from-blue-500 to-cyan-600
                  rounded-xl sm:rounded-2xl flex items-center justify-center transform hover:scale-105 transition-transform duration-300 shadow-lg shadow-blue-500/30">
                  <Calendar className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white" />
                </div>
                <div className="text-center">
                  <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-1 sm:mb-2">
                    Importer les progressions
                  </h1>
                  <p className="text-gray-600 text-xs sm:text-sm md:text-base">
                    Utilisez un fichier <strong>CSV</strong> pour importer facilement votre progression de séquence.
                  </p>
                </div>
              </div>

              {/* Calendrier scolaire indisponible : l'import est impossible
                  sans les périodes — bandeau + Réessayer plutôt qu'un échec
                  silencieux à la validation */}
              {periodesErreur ? (
                <div className="flex items-center gap-3 mb-4 sm:mb-6 px-4 py-3 rounded-xl border border-amber-300 bg-amber-50">
                  <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />
                  <p className="text-xs sm:text-sm text-amber-800 flex-1">
                    Le calendrier scolaire n'a pas pu être chargé : l'import a besoin des périodes pour calculer les dates des séquences.
                  </p>
                  <button
                    type="button"
                    onClick={chargerCalendrier}
                    className="flex-shrink-0 px-3 py-1.5 rounded-lg text-xs font-bold text-white bg-amber-500 hover:bg-amber-600 transition"
                  >
                    Réessayer
                  </button>
                </div>
              ) : null}

              {/* Zone de drag & drop */}
              <div
                className={`border-2 border-dashed rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 mb-4 sm:mb-6 transition-all duration-300 cursor-pointer ${
                  dragOver
                    ? 'border-blue-500 bg-blue-50 scale-[1.02]'
                    : selectedFile && !validationResults
                      ? 'border-emerald-400 bg-emerald-50'
                      : 'border-gray-300 bg-gray-50 hover:border-blue-400 hover:bg-blue-50'
                }`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={openFileDialog}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept=".csv"
                  className="hidden"
                />

                <div className="text-center">
                  <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 mx-auto mb-3 sm:mb-4 rounded-xl sm:rounded-2xl flex items-center justify-center transition-all duration-300 ${
                    selectedFile && !validationResults
                      ? 'bg-emerald-500'
                      : 'bg-gradient-to-br from-blue-500 to-cyan-600'
                  }`}>
                    {selectedFile && !validationResults ? (
                      <Check className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white" />
                    ) : (
                      <Upload className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white" />
                    )}
                  </div>
                  <div className="text-sm sm:text-base md:text-lg font-medium text-gray-700 mb-1 sm:mb-2">
                    {selectedFile && !validationResults
                      ? (
                        <span className="text-emerald-700">
                          <span className="hidden sm:inline">Fichier sélectionné : </span>
                          <span className="bg-emerald-100 px-2 py-1 rounded-lg text-xs sm:text-sm break-all">{selectedFile.name}</span>
                        </span>
                      )
                      : 'Glissez votre fichier CSV ici'
                    }
                  </div>
                  <div className="text-xs sm:text-sm text-gray-500">
                    {selectedFile && !validationResults
                      ? 'Prêt à importer !'
                      : 'ou cliquez pour parcourir vos fichiers'
                    }
                  </div>
                </div>
              </div>

              {/* Boutons d'action */}
              <div className="flex flex-col gap-2 sm:gap-3 mb-4 sm:mb-6">
               
                <TemplateProgressionNiveau selectedNiveau={selectedNiveau}/>
              </div>

              {/* Erreurs de validation */}
              {validationResults?.errors.length > 0 && renderValidationErrors()}
            </>
          )}

          {validationResults?.errors.length === 0 && previewData && periode && etape === 2 && (
            <PreviewSequence
              sequencesWithDates={previewData}
              setPreviewData={setPreviewData}
              handleBackStep={handleBackStep}
              periodes={periode}
              selectedNiveau={selectedNiveau}
              setApiData={setApiData}
              setEtape={setEtape}
              selectedAttendus={selectedAttendus}
              setSelectedAttendus={setSelectedAttendus}
              ThemeDetail={ThemeDetail}
            />
          )}

          {validationResults?.errors.length === 0 && apiData && periode && etape === 3 && (
            <ValidationImportSequence
              sequencesWithDates={previewData}
              selectedAttendus={selectedAttendus}
              ThemeDetail={ThemeDetail}
            />
          )}
        </div>

        {/* Footer avec boutons - visible à l'étape 2 */}
        {etape === 2 && (
          <div className="flex-shrink-0 flex items-center justify-center p-4 sm:p-6 gap-4 sm:gap-5 bg-white border-t border-gray-200">
            <button
              onClick={handleBackStep}
              className="flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3
                bg-gradient-to-r from-orange-400 to-amber-500 hover:from-orange-500 hover:to-amber-600
                text-white rounded-xl font-medium text-sm sm:text-base shadow-lg shadow-orange-500/30
                hover:shadow-xl hover:shadow-orange-500/40 hover:scale-[1.02] active:scale-[0.98]
                transition-all duration-300"
            >
              <span>←</span>
              <span>RETOUR</span>
            </button>
            <button
              onClick={handleNextStep}
              className="flex items-center gap-2 px-6 sm:px-8 py-2.5 sm:py-3
                bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600
                text-white rounded-xl font-medium text-sm sm:text-base shadow-lg shadow-emerald-500/30
                hover:shadow-xl hover:shadow-emerald-500/40 hover:scale-[1.02] active:scale-[0.98]
                transition-all duration-300"
            >
              <span>Suivant</span>
              <span>→</span>
            </button>
          </div>
        )}

        {/* Footer avec boutons - visible à l'étape 3 */}
        {etape === 3 && (
          <div className="flex-shrink-0 flex items-center justify-center p-4 sm:p-6 gap-4 sm:gap-5 bg-white border-t border-gray-200">
            <button
              onClick={handleBackStep}
              className="flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3
                bg-gradient-to-r from-orange-400 to-amber-500 hover:from-orange-500 hover:to-amber-600
                text-white rounded-xl font-medium text-sm sm:text-base shadow-lg shadow-orange-500/30
                hover:shadow-xl hover:shadow-orange-500/40 hover:scale-[1.02] active:scale-[0.98]
                transition-all duration-300"
            >
              <span>←</span>
              <span>Modifier</span>
            </button>
            <button
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="flex items-center gap-2 px-6 sm:px-8 py-2.5 sm:py-3
                bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600
                text-white rounded-xl font-medium text-sm sm:text-base shadow-lg shadow-emerald-500/30
                hover:shadow-xl hover:shadow-emerald-500/40 hover:scale-[1.02] active:scale-[0.98]
                transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            >
              {isSubmitting ? (
                <>
                  <span className="animate-spin">⏳</span>
                  <span>Enregistrement...</span>
                </>
              ) : (
                <>
                  <Check className="w-5 h-5" />
                  <span>Valider et enregistrer</span>
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </Modal>
    );
  };
  
  export default ImportProgressionNiveau;
  